import React from "react";

import Radio from "@cayuse/shared-react.components.form.inputs.radio";

import Tooltip from "components/Tooltip";
import useDictionary from "hooks/useDictionary";

import styles from "../SummaryBudget.css";

export const BudgetInputSelector = ({ config, inputType, onChange }) => {
	const dictionary = useDictionary("summaryBudget");
	const defaultInputTypes = dictionary.inputTypes;
	const buttonText = dictionary.buttons;

	const onChangeRadio = event => {
		onChange(event.target.value, config);
	};

	return (
		<div role="group" aria-labelledby="budget-summary-label">
			<Tooltip id={config.id} tooltipContent={config.tooltip || config.extraSettings.tooltip}>
				<h3 className={styles.bold}>{dictionary.title || "Budget Summary"}</h3>
			</Tooltip>
			<br />
			<p id="budget-summary-label">{dictionary.inputTypeQuestion || "How would you like to show your budget?"}</p>
			<div className={styles.radioOptions}>
				<Radio
					checked={inputType === defaultInputTypes.manual || !inputType}
					id={defaultInputTypes.manual}
					name={defaultInputTypes.manual}
					onChange={onChangeRadio}
					value={defaultInputTypes.manual}
					disabled={!config.enabled}
				>
					{buttonText.manual || "Manually enter budget information"}
				</Radio>
				<Radio
					checked={inputType === defaultInputTypes.builder}
					id={defaultInputTypes.builder}
					name={defaultInputTypes.builder}
					onChange={onChangeRadio}
					value={defaultInputTypes.builder}
					disabled={!config.enabled}
				>
					{buttonText.builder || "Display summary from Budget Builder"}
				</Radio>
			</div>
		</div>
	);
};

export default BudgetInputSelector;
